import PropTypes from 'prop-types';
import React from 'react';

import {
  filter as getFilterResults,
  getFilterHash,
  getFilterFromQS,
} from 'redux/modules/browse';

import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import BrowseHeader from 'components/Browse/Header/BrowseHeader';
import BrowseFilter from 'components/Browse/Filter/BrowseFilter';
import BrowseResults from 'components/Browse/Results/BrowseResults';
import BrowsePagination from 'components/Browse/Pagination/BrowsePagination';
import CallToAction from 'components/Shared/CallToAction/CallToAction';

import { trackEvent } from 'helpers/Analytics';

import styles from './Browse.module.scss';

export default class Browse extends React.Component {
  //

  static propTypes = {
    location: PropTypes.object,
    authUser: PropTypes.object,
    filterResults: PropTypes.any,
  };

  componentDidMount() {
    const { location, authUser } = this.props;
    const filter = getFilterFromQS(location);
    const hash = getFilterHash(filter);

    const { filterResults } = this.props;
    const totalPages = filterResults.getIn([hash, 'totalPages'], 0);

    const browsePage =
      location.query && location.query.page ? location.query.page : '0';

    if (browsePage !== '1' || totalPages !== 0) {
      trackEvent('user-lands-on-browse', {
        browse_page: browsePage,
        total_browse_pages: totalPages,
        loggedIn: !!authUser,
        userType: authUser ? authUser.type : 'guest',
      });
    }
  }

  render() {
    const { location, authUser } = this.props;
    return (
      <Grid>
        <BrowseHeader />

        <Row className={styles.browseContainer}>
          <Col
            xs={12}
            sm={12}
            md={3}
            mdOffset={0}
            lg={3}
            className={styles.filterContainer}
          >
            <BrowseFilter location={location} />
            <CallToAction
              cta="Twine Business"
              buttonText="Learn more"
              to="/enterprise"
              panelText="Save time finding the perfect freelancer with Twine Business. Promotion, sourcing and vetting."
            />
          </Col>

          <Col xs={12} sm={12} md={9} lg={9}>
            <BrowseResults location={location} />
            {authUser && <BrowsePagination location={location} />}
          </Col>
        </Row>
      </Grid>
    );
  }
}
